import { api } from "@/lib/api";

export async function fetchHomeSections() {
  try {
    const { data } = await api.get("/ecom/cms/sections", {
      params: { placement: "home", status: "published" },
    });
    const list = Array.isArray(data) ? data : data?.sections || data?.items || [];
    return list
      .filter((s) => s && s.type)
      .sort((a, b) => (a.position ?? a.sort_order ?? 0) - (b.position ?? b.sort_order ?? 0));
  } catch {
    return null;
  }
}
